import { SalariesRecentSubmission } from 'modules/salaries/types/SalariesRecentSubmission';
import { getJson } from 'utils/http';

export async function salariesFetchRecentSubmissions(): Promise<
  SalariesRecentSubmission[]
> {
  const { recentSubmissions } = await getJson<{
    recentSubmissions: SalariesRecentSubmission[];
  }>('/data/salary-surveys/recent-submissions');

  return recentSubmissions;
}
